import { Injectable } from '@angular/core';
import { jwtDecode } from "jwt-decode";
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Entitlements } from '../../models/entitlements.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private userPermissions$: Observable<string[]> | null = null;

  constructor(
    private oidcSecurityService: OidcSecurityService
  ) { }

  // This file used to do a bunch of auth stuff,
  // but none of it was needed once angular-auth-oidc-client was added.
  // Now it only exists to change the return type of jwtDecode to any.
  // The original type is too strict and does not allow for custom claims.
  // There is probably a better way to do this.
  decodeJWT(token: string): any {
    return jwtDecode(token);
  }

  private getUserPermissions(): Observable<string[]> {
    if (!this.userPermissions$) {
      this.userPermissions$ = this.oidcSecurityService.getUserData().pipe(
        map((data) => (data?.appGroups) || []),
        shareReplay(1)
      );
    }
    return this.userPermissions$;
  }

  isUserHasEditPermission(): Observable<boolean> {
    return this.getUserPermissions().pipe(
      map((userPermissions) => userPermissions.includes(Entitlements.NQ_FAST_EDIT))
    );
  }

  isUserHasReadPermission(): Observable<boolean> {
    return this.getUserPermissions().pipe(
      map((userPermissions) =>
        userPermissions.includes(Entitlements.NQ_FAST_READ) ||
        userPermissions.includes(Entitlements.NQ_FAST_EDIT)
      )
    );
  }

}
